import PropTypes from 'prop-types';

const SurveyID = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
]).isRequired;

const SurveyValue = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
]);

export const SurveyAnswerType = PropTypes.shape({
  id: SurveyID,
  label: PropTypes.string.isRequired,
  value: SurveyValue,
});

export const SurveyQuestionType = PropTypes.shape({
  id: SurveyID,
  label: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  answers: PropTypes.arrayOf(SurveyAnswerType).isRequired,
});

const SurveyType = PropTypes.shape({
  questions: PropTypes.arrayOf(SurveyQuestionType).isRequired,
  comment: PropTypes.string,
  installer: PropTypes.shape({
    name: PropTypes.string,
  }),
  resolution: PropTypes.string,
});

export default SurveyType;



// WEBPACK FOOTER //
// ./client/app/shared/types/survey.js